<app-confirm-modal></app-confirm-modal>

<mat-drawer-container class="sidenav-container">
  <mat-drawer
    class="sidenav-sidenav"
    [mode]="navbarService.modeMenu"
    position="start"
    [opened]="navbarService.isOpenedMenu | async"
    (opened)="navbarService.openMenu()"
    (closed)="navbarService.closeMenu()">
    <div class="mat-drawer-header">
      <img src="assets/Tongo_logo.svg" alt="Tongo Logo" />
    </div>
    @if ( !!(authService.authUser | async) && !(authService.authUser |
    async)?.mfaRequired ) {
    <div class="sidenav-content">
      <mat-accordion multi>
        @for (group of navbarService.groups; track group) {
        <mat-expansion-panel
          [expanded]="
            group.opened || (group.items | includesActiveInLinks: router.url)
          "
          [disabled]="group.items | includesActiveInLinks: router.url"
          (expandedChange)="
            group.opened = $event; navbarService.updatedLeftMenu()
          ">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ group.title }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-nav-list>
            @for (link of group.items; track link) { @if (link.href) {
            <a
              class="navbar-item"
              mat-list-item
              [href]="link.href | safe"
              [target]="'_blank'">
              <mat-icon fontSet="material-icons-outlined">{{
                link.icon
              }}</mat-icon>
              <span class="navbar-item-text">{{ link.title }}</span>
            </a>
            } @if (link.path) {
            <a
              class="navbar-item"
              mat-list-item
              [class.active]="link | includesActiveInLinks: router.url"
              [routerLink]="link.path">
              <mat-icon fontSet="material-icons-outlined">{{
                link.icon
              }}</mat-icon>
              <span class="navbar-item-text">{{ link.title }}</span>
            </a>
            } }
          </mat-nav-list>
        </mat-expansion-panel>
        }
      </mat-accordion>
      <mat-nav-list>
        <a class="navbar-item" mat-list-item routerLink="/profile">
          <mat-icon fontSet="material-icons-outlined">manage_accounts</mat-icon>
          <span class="navbar-item-text">Profile</span>
        </a>
        <a class="navbar-item" mat-list-item (click)="authService.logout()">
          <mat-icon fontSet="material-icons-outlined">logout</mat-icon>
          <span class="navbar-item-text">Log Out</span>
        </a>
      </mat-nav-list>
      <!--      <mat-nav-list>-->
      <!--        <a *ngFor="let link of navbarService.items"-->
      <!--           class="navbar-item"-->
      <!--           mat-list-item-->
      <!--           routerLinkActive="active"-->
      <!--           [routerLink]="link.path">-->
      <!--          <mat-icon fontSet="material-icons-outlined">{{link.icon}}</mat-icon>-->
      <!--          <span class="navbar-item-text">{{link.title}}</span>-->
      <!--        </a>-->
      <!--      </mat-nav-list>-->
    </div>
    }
    <span class="version-number full-width">{{ navbarService.version }}</span>
  </mat-drawer>

  <div class="page-body">
    <app-navbar></app-navbar>
    <div class="content-wrapper">
      <router-outlet></router-outlet>
    </div>
  </div>
</mat-drawer-container>
